var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutdent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.396 3.193h10.573V4.39H5.396zM.039.003h15.93V1.2H.039zM.039 12.766h15.93v1.197H.039zM5.396 9.575h10.573v1.197H5.396zM5.396 6.384h10.573v1.197H5.396zM2.187 4.491L0 6.983l2.187 2.491z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutdent);
export default __webpack_public_path__ + "static/media/outdent.0bb7c55de2a533fc3186445d387c87b6.svg";
export { ForwardRef as ReactComponent };